const { __ } = wp.i18n
document.addEventListener('DOMContentLoaded', function (e) {
  const txtBiggerBlock = e.target.querySelector('.text-bigger__block')

  if (txtBiggerBlock) {
    const jsSeoText = txtBiggerBlock.querySelector('.js-seo-text')
    const jsReadMore = txtBiggerBlock.querySelector('.js-read-more')

    if (jsSeoText && jsReadMore) {
      jsReadMore.addEventListener('click', () => {
        jsSeoText.classList.toggle('expand')
        jsReadMore.querySelector('.vn-a-content').innerText =
          jsSeoText.classList.contains('expand')
            ? __('Read less', 'vn')
            : __('Read more', 'vn')
      })
    }
  }
})
